import css from './MenuItem.module.css'

export const styles = {
    menuItem: css['menu_item'],
    isSelected: (isSelected?: boolean) => isSelected && css['menu_item_selected'],
    text: css['menu_item_text'],
    isSelectedText: (isSelected?: boolean) => isSelected && css['menu_item_text_selected'],
}